module.exports = __webpack_public_path__ + "static/img/h4_x2.f551438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h4_x2.png
// module id = bBsT
// module chunks = 1